import { render, staticRenderFns } from "./CreatePurchaseScore.vue?vue&type=template&id=20605119&"
import script from "./CreatePurchaseScore.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports